var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('VDataTable',{ref:"table",attrs:{"items":_vm.items,"headers":_vm.tableHeaders,"disable-pagination":false,"item-key":"_id"},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))])],1)]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }